import { makeStyles } from '@material-ui/core/styles';
import { EVENT_TYPE } from '../../../../constants/index';

const useStyles = makeStyles(theme => ({
  root: {
    '& .fallback-img img': {
      height: '100%',
    },
    '& .main-heading': {
      '& h2': {
        ...theme.palette.common.ellipsis(2),
      }
    },
    '& .slick-arrow': {
      [theme.breakpoints.down('md')]: {
        display: 'none !important',
      },
    },
    '& .MuiButton-endIcon': {
      backgroundColor: ({ pageContentType }) =>
        pageContentType === EVENT_TYPE && theme.mixins.DarkTurquoise(),
    },
    '& .MuiButton-root:hover .MuiButton-endIcon': {
      backgroundColor: ({ pageContentType }) =>
        pageContentType === EVENT_TYPE && theme.mixins.DarkTurquoise(500),
    },
    '& .btnWithBorder': {
      borderWidth: 0,
    },
  },
  rtlClass: {
    '&  [dir="ltr"] .slick-prev::before,& [dir="ltr"] .slick-next::before': {
      content: "''",
    },
    '&  [dir="ltr"] .slick-prev': {
      [theme.breakpoints.up('lg')]: {
        ...theme.mixins.right('5.5%'),
        ...theme.mixins.left('auto'),
      },
    },
    '&  [dir="ltr"] .slick-next': {
      [theme.breakpoints.up('lg')]: {
        ...theme.mixins.right('12.5%'),
      },
    },
    '& .slick-slider': {
      [theme.breakpoints.down('md')]: {
        direction: 'rtl',
      },
    },
    '& .slick-slider .MuiChip-root': {
      whiteSpace: 'unset',
      height: 'auto',
    },
    '& .slick-slider .MuiChip-root .MuiChip-label': {
      whiteSpace: 'unset',
    },
  },
  fallback: {
    '& .fallback-img': {
      paddingTop: '66.67%',
      background: '#ccc',
      '& img': {
        height: '0',
      },
    },
  },
}));

export default useStyles;
